import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { AssignedToComponent } from '../staff/assigned-to/assigned-to.component';
import { TranslateModule } from '@ngx-translate/core';
import { CONSTANTS_CRM } from '@fitness-force/constants';
import { WalkInTrialComponent } from '../walk-in-trial/walk-in-trial.component';
import { ErrorMsgComponent } from 'libs/errors/src/lib/error-msg/error-msg.component';

@Component({
  selector: 'walk-in-tour',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DatePickerModule,
    SelectModule,
    InputTextModule,
    AssignedToComponent,
    WalkInTrialComponent,
    TranslateModule,
    ErrorMsgComponent
  ],
  templateUrl: './walk-in-tour.component.html'
})
export class WalkInTourComponent implements OnInit, OnDestroy {
  @Input() parentForm!: FormGroup;
  @Input() staffList: any[] = [];

  private destroy$ = new Subject<void>();
  tourOutcomes = CONSTANTS_CRM.TOUR_OUTCOME;
  maxDate = new Date();
  assignedTo$ = new BehaviorSubject<number>(0);
  

  ngOnInit() {
    // Set validators for required fields
    if(this.parentForm.get('createWalkInTour')?.value) {
      // Create tour_completed form group if it doesn't exist
      if (!this.parentForm.contains('tour_completed')) {
        const tourCompletedGroup = new FormGroup({
          tour_outcome: new FormControl(null, [Validators.required]),
          notes: new FormControl(null, [Validators.required]),
          scheduled_datetime: new FormControl(new Date(), [Validators.required]),
          assigned_to_staff_id: new FormControl(null, [Validators.required])
        });

        this.parentForm.addControl('tour_completed', tourCompletedGroup);
        this.parentForm.updateValueAndValidity();
      }
    }

    // Subscribe to createWalkInTour changes
    this.parentForm.get('createWalkInTour')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(createTour => {
        if (createTour) {
          this.updateValidation();
        } else {
          this.clearValidation();
        }
      });

      this.parentForm.get('tour_completed.tour_outcome')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(outcome => {
        if (this.parentForm.contains('trial_membership')) {
          this.parentForm.get('trial_membership')?.clearValidators();
          this.parentForm.get('trial_membership')?.updateValueAndValidity({ emitEvent: false });
        }
        // Check if trial_classes control exists, if not create it
        if (this.parentForm.contains('trial_classes')) {
          this.parentForm.get('trial_classes')?.clearValidators();
          this.parentForm.get('trial_classes')?.updateValueAndValidity({ emitEvent: false });
        }
        this.parentForm.updateValueAndValidity();
        if (outcome && outcome.shortname === 'booktrial') {

          this.parentForm.get('tour_completed.notes')?.clearValidators();
          this.parentForm.get('tour_completed.notes')?.updateValueAndValidity({ emitEvent: false });
          
        }
        else{
          this.parentForm.get('tour_completed.notes')?.setValidators([Validators.required]);
          this.parentForm.get('tour_completed.notes')?.updateValueAndValidity({ emitEvent: false });
        }
      });
  }

  private updateValidation() {
    const tourCompletedGroup = this.parentForm.get('tour_completed') as FormGroup;
    if (tourCompletedGroup) {
      Object.keys(tourCompletedGroup.controls).forEach(key => {
        const control = tourCompletedGroup.get(key);
        if (control) {
          control.setValidators([Validators.required]);
          control.updateValueAndValidity({ emitEvent: false });
        }
      });
    }
  }

  private clearValidation() {
    const tourCompletedGroup = this.parentForm.get('tour_completed') as FormGroup;
    if (tourCompletedGroup) {
      Object.keys(tourCompletedGroup.controls).forEach(key => {
        const control = tourCompletedGroup.get(key);
        if (control) {
          control.clearValidators();
          control.updateValueAndValidity({ emitEvent: false });
        }
      });
    }
  }

  getSelectedStaff(event: any) {
    console.log(event);
    this.parentForm.get('assigned_to_staff_id')?.setValue(event.id);
  }

  get assignedToFormControl() {
    return this.parentForm.get('tour_completed.assigned_to_staff_id')!;
  }

  get selectedOutcomeFormControl() {
    return this.parentForm.get('tour_completed.tour_outcome')!;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
} 